import React, { useState, useCallback } from "react";
import styled from "styled-components";
import { FieldInput } from "../styles";

type Props = {
  cardFieldId: number;
  onCreate: (cardFieldId: number, label: string) => Promise<void>;
};

const Wrap = styled.div`
  margin-top: 6px;
`;

const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.7rem;
  color: ${(p) => p.theme.colors.primary};
  opacity: 0.85;

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
`;

const MiniInput = styled(FieldInput)`
  flex: 1;
  min-width: 120px;
  min-height: 30px;
  padding: 0.35rem 0.5rem;
  font-size: 0.72rem;
  border-radius: 8px;
`;

const Action = styled.button`
  font-size: 0.7rem;
  padding: 0.25rem 0.4rem;
  border: none;
  border-radius: 6px;
  background: none;
  cursor: pointer;
  color: ${(p) => p.theme.colors.primary};

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

const ActionMuted = styled(Action)`
  color: ${(p) => p.theme.colors.text};
  opacity: 0.55;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }
`;

export function CardFieldSelectAddOption({ cardFieldId, onCreate }: Props) {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (busy || !label.trim()) return;
    setBusy(true);
    try {
      await onCreate(cardFieldId, label.trim());
      setLabel("");
      setOpen(false);
    } finally {
      setBusy(false);
    }
  }, [busy, cardFieldId, label, onCreate]);

  return (
    <Wrap>
      {!open ? (
        <Trigger type="button" onClick={() => setOpen(true)}>
          + opção
        </Trigger>
      ) : (
        <Row>
          <MiniInput
            placeholder="Nome"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && label.trim() && !busy) {
                e.preventDefault();
                void handleSubmit();
              }
            }}
            aria-label="Nova opção"
            autoFocus
          />
          <Action
            type="button"
            disabled={busy || !label.trim()}
            onClick={() => void handleSubmit()}
          >
            {busy ? "…" : "ok"}
          </Action>
          <ActionMuted
            type="button"
            disabled={busy}
            onClick={() => {
              setOpen(false);
              setLabel("");
            }}
          >
            cancelar
          </ActionMuted>
        </Row>
      )}
    </Wrap>
  );
}
